import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "price-info__old"
}
const _hoisted_3 = { class: "price-info__old-text" }
const _hoisted_4 = { class: "price-info__old-value" }
const _hoisted_5 = { class: "price-info__current" }
const _hoisted_6 = { class: "price-info__currency" }
const _hoisted_7 = { class: "price-info__value" }
const _hoisted_8 = {
  key: 0,
  class: "price-info__asterisk"
}
const _hoisted_9 = { class: "price-info__unit" }
const _hoisted_10 = { class: "price-info__unit-text" }
const _hoisted_11 = {
  key: 0,
  class: "price-info__unit-price"
}
const _hoisted_12 = ["innerHTML"]

import {ref} from 'vue';
  import type Price from '../../types/Price';
  import {t} from '../../utilities/js/translations/translations';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'priceInfo',
  props: {
    value: {},
    showStar: { type: Boolean, default: false },
    showTax: { type: Boolean, default: false },
    showShippingIncluded: { type: Boolean, default: false },
    showSavedPercentage: { type: Boolean, default: false },
    shippingInfoUrl: { default: '' },
    foodSpecificationLink: { default: '' }
  },
  setup(__props: any) {

  const props = __props;

  const messageKey: {[key: string]: any} = ref({
    deliveryInclShip: 'price.incl_vat_incl_ship',
    deliveryInclVat: 'price.incl_vat',
  });

  if (window.__productConfig && window.__productConfig.messageKey) {
    messageKey.value = window.__productConfig.messageKey;
  }

  function getUnitText() {
    let result = t(`product.price.volumeUnit.${props.value.volumeUnit}`);
    if (props.value.unitPrice) {
      if (props.value.packageSize) {
        result += ' (' + props.value.packageSize + ')';
      }
      result += ',';
    }

    return result;
  }

return (_ctx: any,_cache: any) => {
  return (_ctx.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["price-info", {
      'price-info--reduction': _ctx.value.old,
      [`price-info--currency-${_ctx.value.currency}`]: true
    }]),
        "aria-label": _ctx.$t('checkout.basket.position.header.price') + ' ' + _ctx.value.current
      }, [
        (_ctx.value.old)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('price.instead_of')), 1 /* TEXT */),
              _cache[0] || (_cache[0] = _createTextVNode()),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.value.old), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _cache[4] || (_cache[4] = _createTextVNode()),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.value.currency), 1 /* TEXT */),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.value.currentValue), 1 /* TEXT */),
          _cache[2] || (_cache[2] = _createTextVNode()),
          (_ctx.showStar)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_8, "\n        *\n      "))
            : _createCommentVNode("v-if", true)
        ]),
        _cache[5] || (_cache[5] = _createTextVNode()),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(getUnitText()), 1 /* TEXT */),
          _cache[3] || (_cache[3] = _createTextVNode()),
          (_ctx.value.unitPrice)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.value.unitPrice), 1 /* TEXT */),
                (_ctx.value.unit)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("/" + _toDisplayString(_ctx.value.unit), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _cache[6] || (_cache[6] = _createTextVNode()),
        (_ctx.showTax)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "price-info__tax",
              innerHTML: _ctx.$t(_ctx.showShippingIncluded ? messageKey.value.deliveryInclShip : messageKey.value.deliveryInclVat, [_ctx.shippingInfoUrl])
            }, null, 8 /* PROPS */, _hoisted_12))
          : _createCommentVNode("v-if", true)
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}
}

})